import { lazyNamed } from 'src/utils/lazyNamed.ts';
import BidReduction from './pages/BidReduction/index.ts';
import { BidReductionTab } from './pages/BidReduction/types.ts';
import { CompanyFloorRuleFormSearchKey } from './pages/FloorRuleForm/types.ts';
import { PlacementSearchKey } from './pages/TagDetails/containers/Placement/types.ts';
import TagDetails from './pages/TagDetails/index.ts';
import { PlacementDetailsTab, TagDetailsTab } from './pages/TagDetails/types.ts';
import { TagFormSearchKey } from './pages/TagForm/types.ts';
import { TagsListSearchKey } from './pages/TagsList/types.ts';

export {
  BidReductionTab,
  PlacementDetailsTab,
  TagDetailsTab,
  TagFormSearchKey,
  PlacementSearchKey,
  CompanyFloorRuleFormSearchKey,
  TagsListSearchKey,
};

export default {
  BidReduction,
  Helmet: lazyNamed(() => import('./components/Helmet.tsx'), 'Helmet'),
  TagsList: lazyNamed(() => import('./pages/TagsList/index.tsx'), 'TagsList'),
  TagForm: lazyNamed(() => import('./pages/TagForm/index.tsx'), 'TagForm'),
  TagDetails,
  RawScriptsList: lazyNamed(() => import('./pages/RawScriptsList/index.tsx'), 'RawScriptsList'),
  FloorRulesList: lazyNamed(() => import('./pages/FloorRulesList/index.tsx'), 'FloorRulesList'),
  FloorRuleForm: lazyNamed(() => import('./pages/FloorRuleForm/index.tsx'), 'FloorRuleForm'),
  FloorExperimentForm: lazyNamed(() => import('./pages/FloorExperimentForm/index.tsx'), 'FloorExperimentForm'),
  FloorExperimentDetails: lazyNamed(() => import('./pages/FloorExperimentDetails/index.tsx'), 'FloorExperimentDetails'),
  BiddersConfigsList: lazyNamed(() => import('./pages/BiddersConfigsList/index.tsx'), 'BiddersConfigsList'),
  BidderConfigForm: lazyNamed(() => import('./pages/BidderConfigForm/index.tsx'), 'BidderConfigForm'),
};
